<template>
  <div>
    <label v-if="label" class="block text-xs font-medium text-gray-700 mb-1">{{ label }}</label>
    <select
      :value="modelValue === null || modelValue === undefined ? '' : modelValue"
      class="w-full px-2 py-1.5 border border-gray-200 rounded text-sm focus:outline-none focus:border-gray-400"
      @change="onChange($event.target.value)"
      @focus="$emit('focus')"
    >
      <option value="">{{ placeholder }}</option>
      <option
        v-for="option in normalizedOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
/**
 * A select whose "no selection" round-trips as null. The old inline selects
 * bound the placeholder :value="null" but read back $event.target.value — the
 * raw DOM string, '' for a cleared selection — so "no mapping" leaked into
 * configs as '' and passed !== null checks.
 */
export default {
  name: 'MappedSelect',
  props: {
    modelValue: { type: [String, Number], default: null },
    // Strings, or { value, label } objects.
    options: { type: Array, required: true },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '-- None --' },
    // Coerce selected values to Number (for id-valued options).
    numeric: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'focus'],
  computed: {
    normalizedOptions() {
      return this.options.map((o) => (
        typeof o === 'object' && o !== null ? o : { value: o, label: String(o) }
      ));
    },
  },
  methods: {
    onChange(raw) {
      if (raw === '') {
        this.$emit('update:modelValue', null);
        return;
      }
      this.$emit('update:modelValue', this.numeric ? Number(raw) : raw);
    },
  },
};
</script>
